import { updateConsentFromCookie } from "./sparkles/cookies";

updateConsentFromCookie();

console.debug("init_consent_from_cookie.js initialized");
